export default __webpack_public_path__ + "static/media/thumbnail_image008.297b7b43.png";